import AutomatedMessageAcceptedEnquiry from "./AutomatedMessageAcceptedEnquiry";
import "./AutomatedMessageAcceptedEnquiry .scss";

export default AutomatedMessageAcceptedEnquiry;
